import { parseSearchTokens } from '../utils/string.utils';

/** Icon options for IDEA apps, custom Apps tab apps, etc. */

export interface IconOption {
    name: string;
    description: string;
    icon: string;
}

export function icoSearchFn(term: string, item: IconOption): boolean {
    if (!item || (!item.name && !item.description)) {
        return false;
    }
    const tokens = parseSearchTokens(term);
    const searchIn = `${item?.name} ${item?.description}`.toLocaleLowerCase();
    return tokens.every(token => searchIn.indexOf(token) > -1);
}

export const ICON_OPTIONS: Array<IconOption> = [
    {
        name: 'initials',
        icon: '',
        description: 'Use the initials of the app'
    },
    {
        name: 'Analytics',
        icon: 'icon-analytics',
        description: 'analytics, charts'
    },
    {
        name: 'Ambulance',
        icon: 'icon-ambulance',
        description: 'emergency, vehicle'
    },
    {
        name: 'Anchor',
        icon: 'icon-anchor',
        description: 'boat, sea, ship'
    },
    {
        name: 'Apple',
        icon: 'icon-apple',
        description: 'fruit, teacher'
    },
    {
        name: 'Atom',
        icon: 'icon-atom',
        description: 'science, AI'
    },
    {
        name: 'Baby Carriage',
        icon: 'icon-baby-carriage',
        description: 'infant, child'
    },
    {
        name: 'Bacterium',
        icon: 'icon-bacterium',
        description: 'sick, virus'
    },
    {
        name: 'Baseball Field',
        icon: 'icon-baseball-field',
        description: 'sports, game'
    },
    {
        name: 'Baseball',
        icon: 'icon-baseball',
        description: 'sports, game'
    },
    {
        name: 'Bed',
        icon: 'icon-bed',
        description: 'patient, sleep'
    },
    {
        name: 'Bell',
        icon: 'icon-bell',
        description: 'alarm, ring'
    },
    {
        name: 'Bicycle',
        icon: 'icon-bicycle',
        description: 'bike, exercise'
    },
    {
        name: 'Biohazard',
        icon: 'icon-biohazard',
        description: 'danger, chemical'
    },
    {
        name: 'Bolt',
        icon: 'icon-bolt',
        description: 'lightning, electricty'
    },
    {
        name: 'Bone',
        icon: 'icon-bone',
        description: 'x-ray'
    },
    {
        name: 'Book',
        icon: 'icon-book',
        description: 'read, study'
    },
    {
        name: 'Brain',
        icon: 'icon-brain',
        description: 'organ'
    },
    {
        name: 'Bridge',
        icon: 'icon-bridge',
        description: 'network, structure'
    },
    {
        name: 'Bug',
        icon: 'icon-bug',
        description: 'insect, error'
    },
    {
        name: 'Building',
        icon: 'icon-building',
        description: 'library, courthouse'
    },
    {
        name: 'Bullhorn',
        icon: 'icon-bullhorn',
        description: 'announcement'
    },
    {
        name: 'Calculate',
        icon: 'icon-calculate',
        description: 'math'
    },
    {
        name: 'Calendar',
        icon: 'icon-calendar',
        description: 'date, event'
    },
    {
        name: 'Car',
        icon: 'icon-car',
        description: 'vehicle, transportation'
    },
    {
        name: 'Chart: Area',
        icon: 'icon-chart-area',
        description: 'analytics, chart'
    },
    {
        name: 'Chart: Bar',
        icon: 'icon-chart-bar',
        description: 'analytics, chart'
    },
    {
        name: 'Chart: Horizontal Bar',
        icon: 'icon-chart-bar-horiz',
        description: 'analytics, chart'
    },
    {
        name: 'Chart: Line',
        icon: 'icon-chart-line',
        description: 'analytics, chart'
    },
    {
        name: 'Chart: Line (Down)',
        icon: 'icon-chart-line-down',
        description: 'analytics, chart'
    },
    {
        name: 'Chart: Pie',
        icon: 'icon-chart-pie',
        description: 'analytics, chart'
    },
    {
        name: 'Chart: Scatter',
        icon: 'icon-chart-scatter',
        description: 'analytics, chart'
    },
    {
        name: 'Chat',
        icon: 'icon-sms',
        description: 'messages, text, sms'
    },
    {
        name: 'Check',
        icon: 'icon-status-success',
        description: 'ok, success'
    },
    {
        name: 'City',
        icon: 'icon-city',
        description: 'buildings'
    },
    {
        name: 'Clipboard: Medical',
        icon: 'icon-clipboard-medical',
        description: 'notes, detail'
    },
    {
        name: 'Clipboard: Medical (2)',
        icon: 'icon-clipboard-medical-alt',
        description: 'notes, detail'
    },
    {
        name: 'Clock',
        icon: 'icon-clock',
        description: 'time'
    },
    {
        name: 'Cloud',
        icon: 'icon-cloud',
        description: 'weather'
    },
    {
        name: 'Code',
        icon: 'icon-code',
        description: 'machine'
    },
    {
        name: 'Compass',
        icon: 'icon-compass',
        description: 'direction'
    },
    {
        name: 'Construction',
        icon: 'icon-construction',
        description: 'danger, warn'
    },
    {
        name: 'Crown',
        icon: 'icon-crown',
        description: 'king, queen'
    },
    {
        name: 'Crutch',
        icon: 'icon-crutch',
        description: 'accident, injury'
    },
    {
        name: 'Cube',
        icon: 'icon-cube',
        description: 'block, model'
    },
    {
        name: 'Cubes',
        icon: 'icon-cubes',
        description: 'block, model'
    },
    {
        name: 'Database',
        icon: 'icon-database-solid',
        description: 'data, storage'
    },
    {
        name: 'Desktop Computer',
        icon: 'icon-desktop',
        description: 'monitor, screen, tv'
    },
    {
        name: 'Diagram',
        icon: 'icon-diagram-project',
        description: 'map, connection'
    },
    {
        name: 'Diamond',
        icon: 'icon-diamond',
        description: 'jewel, wealth'
    },
    {
        name: 'Doctor',
        icon: 'icon-doctor',
        description: 'MD, nurse'
    },
    {
        name: 'Dollar',
        icon: 'icon-dollar',
        description: 'money, finance'
    },
    {
        name: 'Dove',
        icon: 'icon-dove',
        description: 'peace, charity'
    },
    {
        name: 'Email',
        icon: 'icon-email',
        description: 'envelope, letter'
    },
    {
        name: 'Eye',
        icon: 'icon-eye',
        description: 'visible, view'
    },
    {
        name: 'Feather',
        icon: 'icon-feather',
        description: 'trust, wisdom'
    },
    {
        name: 'File',
        icon: 'icon-file',
        description: 'doc, paper'
    },
    {
        name: 'Fire',
        icon: 'icon-fire',
        description: 'flame, heat'
    },
    {
        name: 'Flag',
        icon: 'icon-flag',
        description: 'banner, issue'
    },
    {
        name: 'Folder',
        icon: 'icon-folder',
        description: 'file, organize'
    },
    {
        name: 'Formula',
        icon: 'icon-formula',
        description: 'math, calculation'
    },
    {
        name: 'Gauge',
        icon: 'icon-gauge',
        description: 'odometer, measure'
    },
    {
        name: 'Gem',
        icon: 'icon-gem',
        description: 'jewel, wealth'
    },
    {
        name: 'Genome',
        icon: 'icon-genome',
        description: 'science, dna'
    },
    {
        name: 'Gift',
        icon: 'icon-gift',
        description: 'feature, present'
    },
    {
        name: 'Glasses',
        icon: 'icon-glasses',
        description: 'eyesight, study'
    },
    {
        name: 'Globe',
        icon: 'icon-globe',
        description: 'world, map'
    },
    {
        name: 'Goal',
        icon: 'icon-goal',
        description: 'arrow, target'
    },
    {
        name: 'Graduation Cap',
        icon: 'icon-grad',
        description: 'school, knowledge'
    },
    {
        name: 'Group',
        icon: 'icon-group',
        description: 'people, population'
    },
    {
        name: 'Guitar',
        icon: 'icon-guitar',
        description: 'music, instrument'
    },
    {
        name: 'Hamburger',
        icon: 'icon-hamburger',
        description: 'food'
    },
    {
        name: 'Hammer',
        icon: 'icon-hammer',
        description: 'tool'
    },
    {
        name: 'Service',
        icon: 'icon-hand-holding-heart',
        description: 'heart, charity'
    },
    {
        name: 'Handshake',
        icon: 'icon-handshake',
        description: 'collaborate, greet'
    },
    {
        name: 'Heart',
        icon: 'icon-heart',
        description: 'vitals, love'
    },
    {
        name: 'Heartbeat',
        icon: 'icon-vitals',
        description: 'vitals'
    },
    {
        name: 'Home',
        icon: 'icon-home',
        description: 'house'
    },
    {
        name: 'Hospital',
        icon: 'icon-hospital',
        description: 'building, clinic'
    },
    {
        name: 'Hospital (2)',
        icon: 'icon-hospital-alt',
        description: 'building, clinic'
    },
    {
        name: 'Key',
        icon: 'icon-key',
        description: 'access, permission'
    },
    {
        name: 'Key',
        icon: 'icon-keyboard',
        description: 'enter, type'
    },
    {
        name: 'Lab',
        icon: 'icon-lab',
        description: 'microscope, science'
    },
    {
        name: 'Laptop',
        icon: 'icon-laptop',
        description: 'computer'
    },
    {
        name: 'Lifesaver',
        icon: 'icon-life-saver',
        description: 'safety'
    },
    {
        name: 'Lightbulb',
        icon: 'icon-lightbulb',
        description: 'idea'
    },
    {
        name: 'Lock',
        icon: 'icon-lock',
        description: 'access, security'
    },
    {
        name: 'Map Marker',
        icon: 'icon-map-marker',
        description: 'location, destination'
    },
    {
        name: 'Medical Briefcase',
        icon: 'icon-medical-briefcase',
        description: 'tools'
    },
    {
        name: 'Medicine',
        icon: 'icon-medicine',
        description: 'clinical, staff'
    },
    {
        name: 'Money',
        icon: 'icon-money-bill',
        description: 'dollar bill, finance'
    },
    {
        name: 'Monitor',
        icon: 'icon-monitor-waveform',
        description: 'waveform, watch'
    },
    {
        name: 'Moon',
        icon: 'icon-moon',
        description: 'night'
    },
    {
        name: 'Number',
        icon: 'icon-number',
        description: 'numeric, hashtag'
    },
    {
        name: 'Paint Brush',
        icon: 'icon-paint-brush',
        description: 'art, color'
    },
    {
        name: 'Palette',
        icon: 'icon-palette',
        description: 'art, color'
    },
    {
        name: 'Paper Plane',
        icon: 'icon-paper-plane',
        description: 'send, fly'
    },
    {
        name: 'Patient',
        icon: 'icon-patient',
        description: 'user, person'
    },
    {
        name: 'Percent',
        icon: 'icon-percent',
        description: 'number, score'
    },
    {
        name: 'Phone',
        icon: 'icon-phone',
        description: 'call, contact'
    },
    {
        name: 'Paw',
        icon: 'icon-paw',
        description: 'animal'
    },
    {
        name: 'Pill',
        icon: 'icon-pill',
        description: 'medication'
    },
    {
        name: 'Plant',
        icon: 'icon-plant',
        description: 'nature, environment'
    },
    {
        name: 'Play',
        icon: 'icon-play',
        description: 'run, go'
    },
    {
        name: 'Prescription Bottle',
        icon: 'icon-prescription-bottle',
        description: 'medication'
    },
    {
        name: 'Procedure',
        icon: 'icon-procedure',
        description: 'patient, hammer'
    },
    {
        name: 'Queue',
        icon: 'icon-queue',
        description: 'list, order'
    },
    {
        name: 'Radiation',
        icon: 'icon-radiation',
        description: 'danger, chemo'
    },
    {
        name: 'Recycle',
        icon: 'icon-recycle',
        description: 'environment'
    },
    {
        name: 'Ribbon',
        icon: 'icon-ribbon',
        description: 'cancer'
    },
    {
        name: 'Umbrella',
        icon: 'icon-risk',
        description: 'risk, weather'
    },
    {
        name: 'Rocket',
        icon: 'icon-rocket',
        description: 'ship, space'
    },
    {
        name: 'Scale',
        icon: 'icon-scale-balanced',
        description: 'equality, justice'
    },
    {
        name: 'Sparkle',
        icon: 'icon-sparkle',
        description: 'ai'
    },
    {
        name: 'Star',
        icon: 'icon-star-o',
        description: 'favorite, rate'
    },
    {
        name: 'Stethoscope',
        icon: 'icon-stethoscope',
        description: 'doctor, vitals'
    },
    {
        name: 'Stopwatch',
        icon: 'icon-stopwatch',
        description: 'time, speed'
    },
    {
        name: 'Sun',
        icon: 'icon-sun',
        description: 'day, weather'
    },
    {
        name: 'Syringe',
        icon: 'icon-syringe',
        description: 'medication'
    },
    {
        name: 'Tags',
        icon: 'icon-tags',
        description: 'label, category'
    },
    {
        name: 'Thumbtack',
        icon: 'icon-thumbtack',
        description: 'pin, location'
    },
    {
        name: 'Toolbox',
        icon: 'icon-toolbox-solid',
        description: 'job, work'
    },
    {
        name: 'Toolbox 2',
        icon: 'icon-toolbox',
        description: 'job, work'
    },
    {
        name: 'Trophy',
        icon: 'icon-trophy-star',
        description: 'award, win'
    },
    {
        name: 'User Circle',
        icon: 'icon-user-circle',
        description: 'person, profile'
    },
    {
        name: 'User',
        icon: 'icon-user',
        description: 'person, profile'
    },
    {
        name: 'Users',
        icon: 'icon-users',
        description: 'group, team'
    },
    {
        name: 'Vial',
        icon: 'icon-vial',
        description: 'medicine, science'
    },
    {
        name: 'Vials',
        icon: 'icon-vials',
        description: 'medicine, science'
    },
    {
        name: 'Virus',
        icon: 'icon-virus',
        description: 'disease'
    },
    {
        name: 'Viruses',
        icon: 'icon-viruses',
        description: 'disease'
    },
    {
        name: 'Walking',
        icon: 'icon-walking',
        description: 'person, travel'
    },
    {
        name: 'Workspace',
        icon: 'icon-workspace',
        description: 'desk, screen'
    },
    {
        name: 'Wrench',
        icon: 'icon-wrench',
        description: 'tool, fix'
    }
];
